import Axios from "@app/api/axios";
import { PRODUCTS } from "@utils/constant";

export const deleteProductDetails = ({ productId }) => {
  return Axios.delete(`${PRODUCTS}/${productId}`).then(response => response);
};